import type {
  Spacing,
  HorizontalAlignment,
  VerticalAlignment,
  TextSize,
  TextWeight,
  TextColor,
  ImageSize,
} from '../types'

export const spacingClasses: Record<Spacing, string> = {
  none: 'mt-0',
  small: 'mt-1',
  default: 'mt-2',
  medium: 'mt-3',
  large: 'mt-4',
  extraLarge: 'mt-6',
}

export const horizontalAlignClasses: Record<HorizontalAlignment, string> = {
  left: 'items-start',
  center: 'items-center',
  right: 'items-end',
}

export const horizontalJustifyClasses: Record<HorizontalAlignment, string> = {
  left: 'justify-start',
  center: 'justify-center',
  right: 'justify-end',
}

export const textAlignClasses: Record<HorizontalAlignment, string> = {
  left: 'text-left',
  center: 'text-center',
  right: 'text-right',
}

export const imageAlignClasses: Record<HorizontalAlignment, string> = {
  left: 'mr-auto',
  center: 'mx-auto',
  right: 'ml-auto',
}

export const verticalAlignClasses: Record<VerticalAlignment, string> = {
  top: 'justify-start',
  center: 'justify-center',
  bottom: 'justify-end',
}

export const textSizeClasses: Record<TextSize, string> = {
  small: 'text-sm',
  default: 'text-base',
  medium: 'text-lg',
  large: 'text-xl',
  extraLarge: 'text-2xl',
}

export const textWeightClasses: Record<TextWeight, string> = {
  lighter: 'font-light',
  default: 'font-normal',
  bolder: 'font-bold',
}

export const textColorClasses: Record<TextColor, string> = {
  default: '',
  dark: 'text-foreground',
  light: 'text-muted-foreground',
  accent: 'text-primary',
  good: 'text-green-600 dark:text-green-400',
  warning: 'text-orange-600 dark:text-orange-400',
  attention: 'text-red-600 dark:text-red-400',
}

export const imageSizeClasses: Record<ImageSize, string> = {
  auto: '',
  stretch: 'w-full',
  small: 'w-10 h-10',
  medium: 'w-20 h-20',
  large: 'w-40 h-40',
}

export function getColumnWidthClass(width: string | number | undefined): string {
  if (width === 'auto') return 'flex-none'
  if (width === 'stretch') return 'flex-1'
  return 'flex-1'
}
